// extracted by mini-css-extract-plugin
export default {"input":"CommonInputDecimal_input__UZ8Gz","label":"CommonInputDecimal_label__0P2VF"};